import type { IAccountStatusHistory, IAgedAccount } from "@apis/accounts/types"
import { type ColumnDef } from "@tanstack/react-table"
import { DateCell, LinkCell, SortingHeader } from "@utils/table/columnFactories"
import { Edit, User } from "lucide-react"
import type { TFilterConfig } from "@components/DataTable/types"

export const agedAccountsColumns: ColumnDef<IAgedAccount>[] = [
  {
    id: "actions",
    header: "Actions",
    cell: ({ row }) => {
      const { membership_profile_id, account_id } = row.original
      return (
        <div className="tw:flex tw:gap-2">
          <LinkCell
            to={`/profiles/${membership_profile_id}/accounts/${account_id}`}
          >
            <User />
            <span>Details</span>
          </LinkCell>
          <LinkCell to={`./${account_id}`}>
            <Edit />
            <span>Edit</span>
          </LinkCell>
        </div>
      )
    },
  },
  {
    accessorKey: "order_dt",
    header: (props) => <SortingHeader {...props} label="Order Date" />,
    cell: (props) => <DateCell {...props} />,
  },
  {
    accessorKey: "channel_code",
    header: (props) => <SortingHeader {...props} label="Channel" />,
    filterFn: "equalsOneOf",
  },
  {
    accessorKey: "channel_partner_code",
    header: (props) => <SortingHeader {...props} label="Channel Partner" />,
    filterFn: "equalsOneOf",
  },
  {
    accessorKey: "market_code",
    header: (props) => <SortingHeader {...props} label="Market Code" />,
    filterFn: "equalsOneOf",
  },
  {
    accessorKey: "status_group",
    header: (props) => <SortingHeader {...props} label="Account Status" />,
  },
  {
    accessorKey: "account_number",
    header: (props) => <SortingHeader {...props} label="Account Number" />,
  },
  {
    accessorKey: "last_name",
    header: (props) => <SortingHeader {...props} label="LastName" />,
    filterFn: "includesString",
  },
]

export const agedAccountsFilters: TFilterConfig[] = [
  {
    type: "text",
    id: "last_name",
    placeholder: "Last Name",
  },
  {
    type: "text",
    id: "account_number",
    placeholder: "Account Number",
  },
  {
    type: "select",
    id: "market_code",
    placeholder: "Market Code",
  },
  {
    type: "select",
    id: "channel_code",
    placeholder: "Channel",
  },
  {
    type: "select",
    id: "channel_partner_code",
    placeholder: "Channel Partner",
  },
]

export const accountStatusHistoriesColumns: ColumnDef<IAccountStatusHistory>[] =
  [
    { accessorKey: "from_status_code", header: "From Code" },
    { accessorKey: "to_status_code", header: "To Code" },
    { accessorKey: "account_status_reason_code", header: "Reason" },
    { accessorKey: "account_status_message", header: "Notes" },
    {
      accessorKey: "status_change_dt",
      header: "Change Date",
      cell: (props) => <DateCell {...props} />,
    },
  ]
